export default __webpack_public_path__ + "static/media/phonics_white.340dda6e.svg";